const AdminSupport = () => {
  return <div>AdminSupport</div>;
};

export {AdminSupport};
